<template>
	<Modal
		ref="modal"
		:overlay-type="modalName"
		:html-classes="['hide--header', 'show--modal']"
		:initial-visible="initialVisible"
		:light="light"
		:full-height="fullHeight"
		v-if="html"
	>
		<div class="overlay-dialog__content" v-html="html"/>
	</Modal>
</template>

<script>
import Modal from '@/components/Modal';

export default {
	components: {
		Modal,
	},
	data() {
		return {
			html: this.$root.options.html,
			light: !!this.$root.options.light,
			fullHeight: !!this.$root.options.fullHeight,
			modalName: this.$root.options.modalName || 'content-overlay',
			initialVisible: !!this.$root.options.initialVisible,
		};
	},
}
</script>

<style>

</style>
